const browsersVisibilityProperties = [
  { hidden: 'hidden', visible: 'visible', eventName: 'visibilitychange' },
  { hidden: 'mozHidden', visible: 'mozvisible', eventName: 'mozvisibilitychange' },
  { hidden: 'msHidden', visible: 'msvisible', eventName: 'msvisibilitychange' },
  { hidden: 'webkitHidden', visible: 'webkitvisible', eventName: 'webkitvisibilitychange' },
];

export const visibilityProperties = browsersVisibilityProperties.find((browser) => {
  return typeof document[browser.hidden] !== 'undefined';
});

export function onVisibilityChange(handler) {
  if (!visibilityProperties) {
    if (!window || !window.Sentry) return;
    window.Sentry.captureException('Browser does not support visibility api');
    return;
  }

  document.addEventListener(visibilityProperties.eventName, () =>
    handler(document.visibilityState)
  );
}
